export default __webpack_public_path__ + "static/media/triangle_edit.276ca471.svg";